import { SVGProps } from 'react';

const ViewIcon = ({
  height = '24px',
  width = '24px',
  strokeWidth = '2',
  className,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 24 24'
    className={className ? className : 'stroke-current fill-current'}
    {...props}
  >
    <g transform='translate(0 -0.009)'>
      <path
        d='M22,12.12,19.4,15A10,10,0,0,1,4.6,15L2,12.12H2L4.32,9.34a10,10,0,0,1,15.36,0Z'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
      />
      <ellipse
        cx='2.6'
        cy='2.5'
        rx='2.6'
        ry='2.5'
        transform='translate(9.49 9.26)'
        strokeLinecap='round'
        strokeLinejoin='bevel'
        strokeWidth={strokeWidth}
      />
    </g>
  </svg>
);

export default ViewIcon;
